import * as React from 'react'
import MuiAlert, { AlertProps } from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant='filled' {...props} />
})

export default function NoPermissionSnackbar({
  handlePermissionSnackbarClose,
  permissionSnackbarOpen
}: SnackbarProps) {
  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return
    }
    handlePermissionSnackbarClose()
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
      open={permissionSnackbarOpen}
      autoHideDuration={6000}
      onClose={handleClose}
    >
      <Alert onClose={handleClose} severity='error'>
        Access denied. Escalate issue to TL to execute the action.
      </Alert>
    </Snackbar>
  )
}

interface SnackbarProps {
  handlePermissionSnackbarClose: () => void
  permissionSnackbarOpen: boolean
}
